function toNumber(value) {
  let str = `${value}`;
  str = str.replace(",", ".");
  str = str.replace(/[^\d,.-]/g, "");
  const float = parseFloat(str);
  return Number.isNaN(float) ? 0 : float;
}

export { toNumber };
//# sourceMappingURL=toNumber.js.map
